import React from "react";
import DateHelpers from '../Helper/DateHelpers.js';
import AddTransaction from '../Routes/AddTransaction.js'
import AccountDetails from "./AccountDetails.js";
import ViewTransactionHistory from './ViewTransactionHistory.js'
import { useNavigate } from "react-router-dom";
import RegistrationInfo from "./RegistrationInfo.js";
import { useState, useEffect } from "react";
import '../Styles/AdminRegistrationCard.scss';
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import RegistrationDetails from "./RegistrationDetails.js";

function AdminRegistrationCard({ queriedRegistration }) {

   console.log("Queried Registration", queriedRegistration)
   const navigate = useNavigate()
   const [AddPaymentVisibility, setAddPaymentVisibility] = useState(false)
   const [viewTransactionsVisibility, setViewTransactionsVisibility]     = useState(false)
   const [viewRegistrationVisibility, setViewRegistrationVisibility]     = useState(false)
   const [viewAccountDetailsVisibility, setViewAccountDetailsVisibility] = useState(false)
   const [currentAmountDue, setCurrentAmountDue] = useState()

   function handleAmountDue() {
      console.log("Here's current amount due", currentAmountDue)
      if (currentAmountDue != null) {
         return currentAmountDue
      }
      else {
         var amountDueString = queriedRegistration.amount_due
         return amountDueString
      }
   }

   function getAmountDue() {
      var amountDueString = queriedRegistration.amount_due
      console.log("Current amount due", amountDueString)
      setCurrentAmountDue(amountDueString)
   }

   useEffect(() => {
      getAmountDue()
   }, [queriedRegistration]);

   return (
      <div className="AdminRegistrationCardContainer">
         <div className="AdminRegistrationCardContent">
            <div className="AdminRegistrationCardEventInfo">
               <div className="AdminRegistrationCardName">
                  {queriedRegistration.first_name + " " + queriedRegistration.last_name}
                  {queriedRegistration.father_son_adventure_son_names?.length > 0 &&
                     <div className="AdminRegistrationCardSons">
                        Sons ({queriedRegistration.father_son_adventure_son_names.length}):{' '}
                        {queriedRegistration.father_son_adventure_son_names.join(", ")}
                     </div>
                  }
               </div>
               <div className="AdminRegistrationCardAccountDetails">
                  <button onClick={() => {
                        setViewAccountDetailsVisibility(true)
                        setViewTransactionsVisibility(false)
                        setAddPaymentVisibility(false)
                        }}>
                     Account Details
                  </button>
               </div>
               <div className="AdminRegistrationCardRegistrationInformationButton">
                  <button onClick={() => { 
                        setViewTransactionsVisibility(false)
                        setAddPaymentVisibility(false)
                        setViewRegistrationVisibility(true)
                     }}>
                        Registration Details
                  </button>
               </div>
               <div className="AdminRegistrationCardEventAmountDue">
                  Amount Due: ${currentAmountDue}
               </div>
               {queriedRegistration.has_paid === false &&
                  <div className="AdminRegistrationCardAddPaymentButton">
                     <button onClick={() => { 
                        setViewAccountDetailsVisibility(false)
                        setViewTransactionsVisibility(false)
                        setViewRegistrationVisibility(false)
                        setAddPaymentVisibility(true)
                     }}>
                        Add Payment
                     </button>
                  </div>
               }
               {queriedRegistration.has_paid === true &&
                  <div className="checkMarkContainer">
                     Paid in Full
                  </div>
               }
               <div className="AdminRegistrationCardTransactionHistoryButton">
                  <button onClick={() => {
                     setViewAccountDetailsVisibility(false)
                     setAddPaymentVisibility(false)
                     setViewRegistrationVisibility(false)
                     setViewTransactionsVisibility(true)
                  }}>
                     View Payment History
                  </button>
               </div>
            </div>
            {AddPaymentVisibility === true &&
            <div className="addTransaction">
               <AddTransaction
                  amount_due={queriedRegistration.amount_due}
                  regist_id={queriedRegistration.regist_id}
                  currentAmountDue={currentAmountDue}
                  setCurrentAmountDue={setCurrentAmountDue}
                  setAddPaymentVisibility={setAddPaymentVisibility} />
            </div>
            }
            {viewTransactionsVisibility === true &&
               <div className="viewTransactionsHistory">
                   <ViewTransactionHistory
                     regist_id={queriedRegistration.regist_id}
                     setViewTransactionsVisibility={setViewTransactionsVisibility}/>
               </div>
            }
            {viewAccountDetailsVisibility === true &&
               <div className="AccountDetails">
                  <AccountDetails
                     registrationInfo={queriedRegistration}
                     setViewAccountDetailsVisibility={setViewAccountDetailsVisibility}
                  />
               </div>
            }
            {viewRegistrationVisibility === true &&
               <div className="RegistrationInfo">
                  <RegistrationDetails
                  registrationInfo={queriedRegistration}
                  setViewRegistrationVisibility={setViewRegistrationVisibility}
                  />
               </div>
            }
         </div>
      </div>
   )
}
export default AdminRegistrationCard;